<template>
  <div class="room-select">
    <RoomSelectButton :isActive="isActive" />
    <RoomSelectContent
      v-if="isShowRoomSelect"
      :rules="rules"
      :tier-info="tierInfo"
      :inner-height="innerHeight"
    />
  </div>
</template>

<script>
import RoomSelectButton from "@/components/room-select/RoomSelectButton";
import RoomSelectContent from "@/components/room-select/RoomSelectContent";
import { mapState } from "vuex";
export default {
  name: "RoomSelect",
  props: {
    isActive: {
      type: Boolean,
    },
    rules: {
      type: Object,
      default: () => {},
    },
    tierInfo: String
  },
  components: {
    RoomSelectButton,
    RoomSelectContent,
  },
  computed: {
    ...mapState({
      isShowRoomSelect: (state) => state.bookingState.roomSelect,
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.innerHeight = window.innerHeight;
    });
  },
};
</script>

<style lang="scss" scoped>
@mixin select-person {
  &__actions {
    display: flex;
    height: 40px;
    text-align: center;
    vertical-align: middle;
    button {
      width: 35px;
    }
    &__minus {
      border-radius: 2px 0 0 2px;
    }
    &__total-count {
      border: 1px solid #e4e4e7;
      width: 46px;
    }
    &__plus {
      border-radius: 0 2px 2px 0;
    }
  }
}
.mb-15 {
  margin-bottom: 15px;
}

.room-select {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  @include min-sm {
    flex-basis: 33%;
  }
  @include min-sm {
    width: fit-content;
    min-width: 96px;
    margin-bottom: 0;
    flex-basis: auto;
  }
}
</style>
